const getSummaries = (state) => state.account && state.account.data && state.account.data.summaries || [];
const getOpportunities = (state) => state.account && state.account.data && state.account.data.opportunities || [];
const getDSAOpportunities = (state) => state.account && state.account.data && state.account.data.dsaOpportunities || [];

export const getAvailableOpportunities = (state) => state.opportunities && state.opportunities.data || [];
export const getHasAvailableOpportunities = (state) => state.account && state.account.hasAvailableOpportunities || {};

export const getSummary = (state, props) => {
  if (!props.dsa) return {};
  const dsa = props.dsa;
  const summaries = getSummaries(state);
  return summaries.find(s => {
    return dsa.id === parseInt(s.ssep_summary_id__c) || dsa.uuid === s.ssep_summary_id__c;
  });
};

export const getLinkedOpportunities = (state, props) => {
  if (!props.dsa) {
    return [];
  }
  const summary = getSummary(state, props);
  if (!summary) return [];
  const dsa = props.dsa;
  const opportunities = getOpportunities(state).concat(getAvailableOpportunities(state));
  const links = getDSAOpportunities(state).filter(o => {
    let linkedOppExternalId = o.ssep_summary__r__ssep_summary_id__c;
    return dsa.id === parseInt(linkedOppExternalId) || dsa.uuid === linkedOppExternalId;
  });
  return links
    .map(link => {
      return opportunities.find(o => link.opportunity__c === o.sfid);
    });
};



// WEBPACK FOOTER //
// ./src/selectors/dsa/opportunitiesSelectors.js